import { render, staticRenderFns } from "./formsCard.vue?vue&type=template&id=059ccd89&"
import script from "./formsCard.vue?vue&type=script&lang=js&"
export * from "./formsCard.vue?vue&type=script&lang=js&"
import style0 from "./formsCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports